module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-LightItalic.33f29a28.ttf";